import { Dishes } from "../kitchen/kitchen.types";

export enum CART_ACTION_TYPES {
  SET_CART_ITEMS = "cart/SET_CART_ITEMS",
  SET_IS_CART_OPEN = "cart/SET_IS_CART_OPEN",
  SET_CART_COUNT = "cart/SET_CART_COUNT",
  SET_CART_TOTAL = "cart/SET_CART_TOTAL",
  SET_CART_KITCHEN_ID = "cart/SET_CART_KITCHEN_ID",
  SET_SCHEDULED_TIME = "cart/SET_SCHEDULED_TIME",
  SET_ORDER_NOTE = "cart/SET_ORDER_NOTE",
  SET_CUSTOMER_DETAILS = "cart/SET_CUSTOMER_DETAILS",
  SET_DISCOUNT = "cart/SET_DISCOUNT",
  CLEAR_DISCOUNT = 'cart/CLEAR_DISCOUNT',
  SET_NEW_CUSTOMER = "cart/SET_NEW_CUSTOMER",
  CLEAR_NEW_CUSTOMER = "cart/CLEAR_NEW_CUSTOMER",
  SET_CUSTOMER_ACCOUNT_CACHE = "cart/SET_CUSTOMER_ACCOUNT_CACHE",
  CLEAR_CUSTOMER_ACCOUNT_CACHE = "cart/CLEAR_CUSTOMER_ACCOUNT_CACHE",
  SET_PAYMENT_PROCESSING = "cart/SET_PAYMENT_PROCESSING",
  SET_DELIVERY_ADDRESS = "cart/SET_DELIVERY_ADDRESS",
}

export type CartItem = Dishes & {
    quantity: number;
    note?: string | null;
    discountName?: string;
    discountValue?: string | number;
    discountType?: string;
    discountReason?: string;
    isBundle?: boolean;
    isSplit?: boolean;
    bundleParentId?: string;
    bundleTemplateId?: string;
    bundleSignature?: string;
    bundleStepId?: string;
    bundleStepName?: string;
    priceAdjustment?: number;
    allocatedPrice?: number;
    allocatedPriceWithVariants?: number;
}

export type CustomerDetails = {
  customerName: string;
  customerEmail: string;
  customerMobile: string;
}

export type CustomerAccountCache = {
  customerAccountId: string;
  kitchenId: string;
  identityKey: string;
};

export type { DeliveryAddress } from "../../utils/deliveryAddress";
